/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class AnvendelsesOmraaderService extends __BaseService {
static readonly getLangVejledningPath = '/anvendelsesomraader/{kode}/langvejledning';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param kode undefined
   * @return Success
   */
  private getLangVejledningResponse(kode: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/anvendelsesomraader/${encodeURIComponent(String(kode))}/langvejledning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param kode undefined
   * @return Success
   */
  getLangVejledning(kode: string): __Observable<string> {
    return this.getLangVejledningResponse(kode).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module AnvendelsesOmraaderService {
}

export { AnvendelsesOmraaderService }
